import validator from './validator';
import parseISO from 'date-fns/parseISO';
import isDate from 'date-fns/isDate';
const compares = reference => (reducer, predicate, error) => {
  if (reference.length === 0)
    throw new TypeError('reference dates cannot be empty');

  const bound = reference.map(e => e).reduce(reducer);
  if (isDate(bound)) {
    return validator(predicate(bound), error, bound);
  } else {
    const boundDate = parseISO(bound);
    return validator(predicate(boundDate), error, boundDate);
  }
};

const dates = {
  isStrictlyAfter: (...reference) => {
    const reducer = (a, b) => (a > b ? a : b);
    const predicate = bound => v => {
      console.log('isStrictlyAfter pred', bound, typeof bound, v, typeof v);
      if (!v) return true;
      if (isDate(v)) {
        return bound < v;
      } else {
        return bound < parseISO(v);
      }
    };

    return compares(reference)(
      reducer,
      predicate,
      'validation.date.isStrictlyAfter'
    );
  },
  isAfter: (...reference) => {
    const reducer = (a, b) => {
      return a > b ? a : b;
    };
    const predicate = bound => v => {
      if (!v) return true;
      if (isDate(v)) {
        return bound <= v;
      } else {
        const parsed = parseISO(v);
        return bound <= parsed;
      }
    };
    return compares(reference)(reducer, predicate, 'validation.date.isAfter');
  },
  isStrictlyBefore: (...reference) => {
    const reducer = (a, b) => (a < b ? a : b);
    const predicate = bound => v => (v ? bound > new Date(v) : true);

    return compares(reference)(
      reducer,
      predicate,
      'validation.date.isStrictlyBefore'
    );
  },
  isBefore: (...reference) => {
    const reducer = (a, b) => (a < b ? a : b);
    const predicate = bound => v => {
      if (!v) return true;
      if (isDate(v)) {
        return bound >= v;
      } else {
        const parsed = parseISO(v);
        return bound >= parsed;
      }
    };

    return compares(reference)(reducer, predicate, 'validation.date.isBefore');
  }
};

export default dates;
